// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-system-sytem-under-reconstruction-wrapper-bgtpk{align-items:center;display:flex;flex-direction:column;height:100vh;justify-content:center;padding:24px;text-align:center}.components-system-sytem-under-reconstruction-logo-nbiip{width:240px}.components-system-sytem-under-reconstruction-text-ylxff{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "components-system-sytem-under-reconstruction-wrapper-bgtpk",
	"logo": "components-system-sytem-under-reconstruction-logo-nbiip",
	"text": "components-system-sytem-under-reconstruction-text-ylxff"
};
module.exports = ___CSS_LOADER_EXPORT___;
